import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext({});
export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("cart", JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const found = cur.find((i) => i.product_id === product.id);
      if (found) return cur.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...cur, { product_id: product.id, name: product.name, brand: product.brand, price: product.price, image: product.images?.[0], quantity: qty }];
    });
  };
  const remove = (pid) => setItems((c) => c.filter((i) => i.product_id !== pid));
  const setQty = (pid, q) => setItems((c) => c.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>{children}</CartContext.Provider>;
};
export const useCart = () => useContext(CartContext);
